/*
 * Runtime webpack public path.
 *
 * The frontend is built ONCE and served from N per-country instances, each under
 * its own internationalized static prefix (e.g. /it-it/static/, /global/static/).
 * Async chunks and assets loaded by webpack at runtime would otherwise use the
 * public path baked in at build time, forcing one build per instance.
 *
 * Django injects the per-instance STATIC_URL as `window.__WEBPACK_PUBLIC_PATH__`
 * before the bundles load (see templates/project/base.html). We assign it to the
 * magic `__webpack_public_path__` variable, which webpack compiles into
 * `__webpack_require__.p`, so every runtime-resolved URL gets the right prefix.
 *
 * This module is prepended as the first entry of every page (see vue.config.js),
 * so it runs before any import(). When the global is absent — e.g. the standalone
 * `v-serve` dev server, which has no Django — it no-ops and the build-time
 * fallback is kept.
 */
if (typeof window !== 'undefined' && window.__WEBPACK_PUBLIC_PATH__) {
  // eslint-disable-next-line no-undef, camelcase
  __webpack_public_path__ = window.__WEBPACK_PUBLIC_PATH__;
}
